import setDocumentData from './setDocumentData';
import {
  ADD_SELECT_ALL,
  SUBTRACT_SELECT_ALL,
} from '../../../../../../../../../constants/slate/documentOps';

export default (params) => {
  const { editor, node, props } = params;

  const {
    value: { document: currentDocument },
  } = editor;

  /**
   * Organization data
   */
  // const { key: organizationDetailsKey, type } = node;

  const organizationNode = node;
  const {
    key: organizationKey,
    data: organizationData,
    nodes: organizationNodes,
  } = organizationNode;
  const organizationDataJSON = organizationData.toJSON();
  const { selectAll: organizationSelectAll } = organizationDataJSON;

  /**
   * Document data
   */
  const { data: currentDocumentData } = currentDocument;
  const currentDocumentDataJSON = currentDocumentData.toJSON();
  const { rolesCount } = currentDocumentDataJSON;

  /**
   * For every organization, there is one organization details card &
   * n number of duo's - role card, empty_paragraph
   */

  const roles = organizationNodes.slice(1);
  const rolesSize = roles.size;

  let selectAllCount;
  let documentRolesCount = rolesCount;

  /**
   * If organization is pre-checked, then nullify the selectAll count to 0 & subtract the roles from document rolesCount
   * Else make it to be the no of roles & add to the document rolesCount
   */

  if (organizationSelectAll === 0) {
    selectAllCount = rolesSize;
    // Before checking the select all of org, there might be few pre checked roles, we need to subtract them
    documentRolesCount += rolesSize - organizationSelectAll;
  } else {
    selectAllCount = 0;
    documentRolesCount -= organizationSelectAll;
  }

  /**
   * Use case:  Update check mark on organization
   */
  editor.moveToStartOfNode(node).setNodeByKey(organizationKey, {
    data: {
      ...organizationDataJSON,
      selectAll: selectAllCount,
    },
  });

  /**
   * Use case:  Update check marks on roles
   */
  roles.forEach((role) => {
    const { key: roleKey, data: roleData } = role;
    const roleJSON = roleData.toJSON();
    editor.setNodeByKey(roleKey, {
      data: {
        ...roleJSON,
        toExport: selectAllCount > 0,
      },
    });
  });

  let documentUpdateType;
  if (selectAllCount) {
    documentUpdateType = ADD_SELECT_ALL;
  } else {
    documentUpdateType = SUBTRACT_SELECT_ALL;
  }

  /**
   * Use case:  Update check mark on left pane
   */
  setDocumentData({
    selectAllCount,
    documentRolesCount,
    props,
    // type,
    currentDocument,
    editor,
    documentUpdateType,
  });
};
